module.exports = __webpack_public_path__ + "static/media/HERINGS_CRO Strategy.991540aa.pdf";